import {PredefinedColumn} from './predefined_columns';
import {ColumnFilter} from './ColumnFilter';
import {TableReportProject} from './TableReportProject';

export class ColumnSelection {
  template: PredefinedColumn;

  index: number | null;
  selected: boolean;
  columnFilters: ColumnFilter[] = [];

  public getValueAsString(project: TableReportProject): string {
    let value;
    try {
      value = this.template.getter(project);
    } catch (exception) {
      console.error('error in getter of predefined column: path=', this.template.path,
        'label=', this.template.label, 'project=', project.id, 'error=', exception);
    }
    /*newRow[col.id + '-val'] = value;*/
    let valueStr;
    if (this.template.makeString) {
      if (value !== null && value !== undefined) {
        try {
          valueStr = this.template.makeString(value);
        } catch (exception2) {
          valueStr = '';
          console.error('error in makeString of predefined column: path=', this.template.path,
            'label=', this.template.label, 'project=', project.id, 'error=', exception2);
        }
      } else {
        valueStr = '';
      }
    } else {
      if (typeof value === 'string') {
        valueStr = value;
      } else if (value !== null && value !== undefined) {
        valueStr = value.toString();
      } else {
        valueStr = '';
      }
    }
    return valueStr;
  }
}
export enum FilterAs {
  date = 'date',
  number = 'number',
  finNumber = 'finNumber',
  string = 'string',
  sri = 'sri',
  percent = 'percent',
}
export class TableColumn {
  name: string;
  prop: string;
  resizeable: boolean;
  summaryFunc: any;
  comparator: any;
  draggable: boolean;
  frozenLeft: boolean;
  width: number;
  sortable: boolean;
}
export class TableRow {
  projectID: string;
}
